<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import BaseSettingsHeader from '../../components/BaseSettingsHeader.vue';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';

const props = defineProps({
  activeTab: {
    type: String,
    default: 'templates',
  },
  inboxes: {
    type: Array,
    default: () => [],
  },
  inboxId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(['update:inboxId']);

const { t } = useI18n();
const router = useRouter();

const TAB_ROUTES = ['whatsapp_templates_index', 'whatsapp_catalog_index'];

const tabs = computed(() => [
  { label: t('WHATSAPP_SETTINGS.TABS.TEMPLATES') },
  { label: t('WHATSAPP_SETTINGS.TABS.CATALOG') },
]);

const activeTabIndex = computed(() => (props.activeTab === 'catalog' ? 1 : 0));

const onTabChange = selectedTab => {
  const targetIndex = tabs.value.findIndex(
    tab => tab.label === selectedTab.label
  );
  if (targetIndex !== -1) router.push({ name: TAB_ROUTES[targetIndex] });
};

const onInboxChange = event => {
  emit('update:inboxId', Number(event.target.value));
};
</script>

<template>
  <div class="flex flex-col w-full gap-4">
    <BaseSettingsHeader
      :title="t('WHATSAPP_SETTINGS.TITLE')"
      :description="t('WHATSAPP_SETTINGS.DESCRIPTION')"
    >
      <template #actions>
        <select
          v-if="inboxes.length > 1"
          :value="inboxId"
          class="h-8 px-2 text-sm rounded-lg outline-1 outline outline-n-weak bg-n-background text-n-slate-12"
          @change="onInboxChange"
        >
          <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
            {{ inbox.name }}
          </option>
        </select>
      </template>
    </BaseSettingsHeader>
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeTabIndex"
      @tab-changed="onTabChange"
    />
  </div>
</template>
